// Messages from the phone app (Robot-Remote-Android-App, chat button).
//
// The app sends them on the robot backend's Socket.IO /message channel; the
// backend relays each one unchanged to every listener, this page included.
//
//   "eng:Hello"   say it in English      "ai:yes"  voice assistant on
//   "beng:..."    say it in Bengali      "ai:no"   voice assistant off
//   "hin:..."     say it in Hindi
//
// Objects, from builds with the emotion picker:
//   { type: "say", lang: "eng" | "beng" | "hin", text, emotion }  say it, wearing
//                                                                 that emotion
//   { type: "emotion", emotion }                                  just the emotion
// Older builds sent { type: "eng" | "ben" | "AI", text }.

import { KNOWN_EMOTIONS } from "./Face/bella/params";

const LANGUAGES = {
	eng: "en-IN",
	en: "en-IN",
	beng: "bn-IN",
	ben: "bn-IN",
	bn: "bn-IN",
	hin: "hi-IN",
	hi: "hi-IN",
};

/**
 * @returns {{ say: string, language: string, emotion: string | null }
 *   | { emotion: string } | { ai: boolean } | null}
 */
export function parseAppMessage(msg) {
	if (msg && typeof msg === "object") {
		if (msg.type === "AI") return { ai: msg.text === "yes" };
		if (msg.type === "emotion") {
			const e = knownEmotion(msg.emotion);
			return e ? { emotion: e } : null;
		}
		if (msg.type === "say") return say(msg.text, LANGUAGES[msg.lang] || "en-IN", knownEmotion(msg.emotion));
		return say(msg.text, LANGUAGES[msg.type] || "en-IN");
	}
	if (typeof msg !== "string") return null;

	// Only the first colon separates the prefix: "eng:Menu: rice and fish" is
	// all one sentence. (String.split with a limit drops the rest.)
	const i = msg.indexOf(":");
	const prefix = i > 0 ? msg.slice(0, i).trim().toLowerCase() : "";
	const rest = msg.slice(i + 1);

	if (prefix === "ai") return { ai: rest.trim().toLowerCase() === "yes" };
	if (LANGUAGES[prefix]) return say(rest, LANGUAGES[prefix]);
	// No known prefix - a colon inside plain text, or no colon at all.
	return say(msg, "en-IN");
}

function say(text, language, emotion = null) {
	const t = typeof text === "string" ? text.trim() : "";
	if (!t) return null;
	return emotion ? { say: t, language, emotion } : { say: t, language };
}

// Only emotions her face can show; anything else is ignored rather than guessed.
function knownEmotion(name) {
	return typeof name === "string" && KNOWN_EMOTIONS.includes(name) ? name : null;
}
